import {useMutation} from "@tanstack/react-query";
import {updateUserManagementProfileMutationOptions} from "./update-user-management-profile.mutation-options";

export function useUpdateUserManagementProfile(userId: string) {
  return useMutation(updateUserManagementProfileMutationOptions(userId));
}
